import styled from "styled-components";

const P = styled.p`
  line-height: 1.5;
`;

export default P;
